<template>
  <div class="dict-manage">
    <table-list
      title="学历标签列表"
      :loading="loading"
      :data="dictList"
      :search-form="searchForm"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :btns="btns(this)"
      :options="{ selection: true }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <DictDialog ref="DictDialog" @success="getList"></DictDialog>
  </div>
</template>

<script>
const btns = _this => [
  {
    label: '添加标签',
    method: _this.handleAdd,
  },
  {
    label: '批量删除',
    method: _this.handleBatchDelete,
    type: 'danger',
  },
]

const searchForm = [
  {
    label: '标签类型',
    type: 'select',
    prop: 'tagType',
    children: [
      { value: 1, label: '学校名称' },
      { value: 2, label: '学历类型' },
    ],
  },
  {
    label: '标签名称',
    prop: 'tagName',
  },
  {
    label: '标签状态',
    type: 'select',
    prop: 'enableStatus',
    children: [
      { value: 1, label: '启用' },
      { value: 2, label: '禁用' },
    ],
  },
]

const columns = _this => [
  {
    prop: 'educationTagId',
    label: '标签ID',
  },
  {
    prop: 'tagType',
    label: '标签类型',
    formatter: row => {
      return row.tagType === 1 ? '学校名称' : '学历类型'
    },
  },
  {
    prop: 'tagName',
    label: '标签名称',
  },
  {
    prop: 'desc',
    label: '备注',
    minWidth: 150,
    twoLines: true,
  },
  {
    label: '启用状态',
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: {
            value: row.enableStatus,
            activeValue: 1,
            inactiveValue: 2,
          },
          on: {
            change: async val => {
              await _this.handleStatusChange(val, row)
            },
          },
        }),
      ]
    },
  },
]

const operates = _this => [
  {
    label: '编辑',
    method: _this.handleEdit,
  },
  {
    label: '删除',
    method: _this.handleDelete,
  },
]

import TableList from '@/components/TableList'
import DictDialog from './components/DictDialog'
import { educationTagList, educationStatusUpdate, educationTagBatchDelete } from '@/api/degree'
import to from 'await-to'

export default {
  name: 'DictManage',
  components: {
    TableList,
    DictDialog,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      operates,
      loading: false,
      dictList: [],
      selectItems: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      queryParams: {},
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(educationTagList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.dictList = res.data.list || []
      this.pager.total = res.data.total || 0
    },
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getList()
    },
    handleAdd() {
      this.$refs.DictDialog.show()
    },
    handleEdit(row) {
      this.$refs.DictDialog.show(row)
    },
    handleDelete(row) {
      this.$confirm('确认删除该标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [, err] = await to(
          educationTagBatchDelete({ educationTagIdList: [row.educationTagId] }),
        )
        if (err) return this.$message.warning(err.msg)
        this.$message.success('删除成功')
        this.getList()
      })
    },
    handleBatchDelete() {
      if (!this.selectItems.length) return this.$message.warning('请先选择要删除的标签')
      const educationTagIdList = this.selectItems.map(item => item.educationTagId)
      this.$confirm('确认删除选中的标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [, err] = await to(educationTagBatchDelete({ educationTagIdList }))
        if (err) return this.$message.warning(err.msg)
        this.$message.success('删除成功')
        this.getList()
      })
    },
    async handleStatusChange(val, row) {
      const [, err] = await to(
        educationStatusUpdate({
          educationTagId: row.educationTagId,
          enableStatus: val,
        }),
      )
      if (err) {
        this.$message.warning(err.msg)
        this.getList()
        return
      }
      this.$message.success('状态更新成功')
      this.getList()
    },
    handleSelectionChange(val) {
      this.selectItems = val
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.dict-manage {
  ::v-deep .operate-group {
    span {
      margin: 0 3px;
    }
  }
}
</style>
